import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import QRCode from 'qrcode.react';
import { useState } from 'react';
import { IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
	dialogContent: {
		marginLeft: '15em',
		marginTop: '-3em',
	},
	qrCode: {
		cursor: 'pointer',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
}));

//material ui animation to slide dialog up
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

//custom re-usable dialog
const QRCodeDialog = ({ url, type }) => {
	const [dialogOpen, setDialogOpen] = useState(false);
	const classes = useStyles();
	const handleClose = () => {
		setDialogOpen(false);
	};
	return (
		<div className={classes.root}>
			<QRCode
				value={url}
				size={170}
				onClick={() => {
					setDialogOpen(true);
				}}
				className={classes.qrCode}
			/>
			<Dialog
				open={dialogOpen}
				data-cy="dialog-component"
				TransitionComponent={Transition}
				keepMounted
				onClose={handleClose}
				fullWidth={true}
				maxWidth="md"
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="alert-dialog-slide-title">
					<Typography variant="body1">{type.toUpperCase()}</Typography>
					<IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent className={classes.dialogContent}>
					<QRCode value={url} size={400} />
				</DialogContent>
			</Dialog>
		</div>
	);
};
export default QRCodeDialog;
